import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import tw, { styled } from "twin.macro";

interface FeatureImageProps extends React.HTMLAttributes<HTMLDivElement> {
  gatsbyImageData?: IGatsbyImageData;
  fallbackImageSrc?: string;
  addShadow?: boolean;
}

const Wrapper = styled.div<{ addShadow?: boolean }>`
  ${tw`rounded-[30px] overflow-hidden`}

  ${(props) => props.addShadow && tw`shadow-blog-image`}
`;

const FeatureImage: React.FunctionComponent<FeatureImageProps> = ({
  gatsbyImageData,
  fallbackImageSrc,
  ...props
}) => {
  if (!gatsbyImageData && !fallbackImageSrc) {
    return null;
  }

  return (
    <Wrapper {...props}>
      {gatsbyImageData && <GatsbyImage image={gatsbyImageData} alt="" />}
      {fallbackImageSrc && <img src={fallbackImageSrc} alt="" />}
    </Wrapper>
  );
};

export default FeatureImage;
